import React from 'react';
import styled from 'styled-components'
import Loader from './Loader'


const Frame = styled.div`
    padding-left: 20vw;
   
`


const Item = styled.div`
    display:flex;
    padding-right: 10vw;
   
    min-width:400px;
    font-size:${({theme}) => (theme.font.size.l)};
`
const Tick = styled.div`
    min-width: 40px;
    color:${({theme}) => (theme.color.success)};
`
const Error = styled.div`
    min-width: 40px;
    color:${({theme}) => (theme.color.warning)};
`
const ServerName = styled.div`
    `


const Status = (props) =>{
    switch(props.status){
        case 'testing':
            return <Loader size={'s'}/>
        case 'pass':
            return <Tick><i className="material-icons"> done </i></Tick>
        case 'fail':
            return <Error><i className="material-icons">error</i></Error>
        default:
            return <Error><i className="material-icons">error</i></Error>
    }
}


export default (props) =>{

    return <Frame>
        <Item>
            <Status status={props.status} err={props.err}/>
    
            <ServerName>{props.resource}</ServerName>
        </Item>
    </Frame>
}


// WEBPACK FOOTER //
// ./src/TestCaseWidget.js